'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { getMb2LoginUrl } from '../config/config';
import { navigateWithFullReferrer } from '../lib/navigateWithFullReferrer';
export type UseMb2Redirect = {
  canRedirect: boolean;
  redirectToMb2: () => void;
};

// Sends a user whose account has not been migrated to MB3 (sourceSystem !==
// 'magento') back to the MB2 (Magento) sign-in page. canRedirect is false when
// no MB2 login URL is configured, so callers can show a message instead of
// leaving the user with no feedback.
export function useMb2Redirect() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getMb2LoginUrl();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const mb2LoginUrl = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (mb2LoginUrl === null) {
        return;
      }
      navigateWithFullReferrer(mb2LoginUrl);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const redirectToMb2 = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      canRedirect: mb2LoginUrl !== null,
      redirectToMb2
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}